var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTibet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e109",
    d: "M0 0v24h30V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#da251c",
    d: "M16 20.23 30 22V2H2v20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M16 12.27V2H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M16 12.27 30 2h-7.01z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M30 7.13v5.14H2v5.13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M30 22v-5L2 7V2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e109",
    d: "m9 11.6 3.5.59a3 3 0 0 0 0 .75l-3.5.58 3.53-.38q.06.34.18.64L9.48 15.2l3.32-1.23q.06.14.14.27h6.12l.14-.27 3.32 1.23-3.23-1.42q.12-.3.18-.64l3.53.38-3.5-.58a3 3 0 0 0 0-.75l3.5-.59-3.53.38q-.06-.33-.18-.64l3.23-1.42-3.32 1.23a3 3 0 0 0-.4-.65l2.68-2.24-2.82 2.08q-.54-.6-1.3-.91l1.16-3.23-1.36 3.16a3.6 3.6 0 0 0-2.32 0L13.48 6.2l1.16 3.23q-.76.31-1.3.9l-2.82-2.07 2.68 2.24q-.24.3-.4.65L9.48 9.92l3.23 1.42q-.12.3-.18.64z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16 12 14 10H2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e87817",
    d: "M18 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M18 18a2 2 0 0 1-4 0 1 1 0 1 1 2 0 1 1 0 1 0 2 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#e87817",
    d: "M15.29 18a.29.29 0 1 1-.58 0 .29.29 0 0 1 .58 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#29166f",
    d: "M17.29 18a.29.29 0 1 1-.57 0 .29.29 0 0 1 .57 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTibet);
export default __webpack_public_path__ + "static/media/tibet.aaca53cce515e4b07498381bce533e7b.svg";
export { ForwardRef as ReactComponent };